var MainCtrl = function ($rootScope, $sessionStorage, role) {
    var self = this;
    this.role = role;
    this.itemsLen = $sessionStorage.items ? $sessionStorage.items.length : 0;
    this.username = $sessionStorage.username;
    
    $rootScope.$watch(function(){
        return $sessionStorage.items ? $sessionStorage.items.length : 0;
    }, function(itemsLen){
        self.itemsLen = itemsLen;
    });
};

module.exports = MainCtrl;



// WEBPACK FOOTER //
// ./client/src/app/modules/main/MainCtrl.js